/** Error messages and codes */
export const ERROR_MESSAGES = {
  GENERIC: "Something went wrong. Please try again later.",
  NOT_AUTHENTICATED: "User is not authenticated!",
  HTTP_ERROR: "HTTP error! status:",
  NULL_RESPONSE_BODY: "Response body is null",
  UNKNOWN_ERROR: "Unknown error"
} as const;

export const ERROR_CODES = {
  CLIENT_ERROR: "CLIENT_ERROR"
} as const;
